module.exports = __webpack_public_path__ + "static/mstile-150x150-80b7ec357330b335ad3b2e7bce771c1c.png";